import { render, staticRenderFns } from "./choose-inspection.vue?vue&type=template&id=038de8ad&scoped=true&"
import script from "./choose-inspection.vue?vue&type=script&lang=js&"
export * from "./choose-inspection.vue?vue&type=script&lang=js&"
import style0 from "./choose-inspection.vue?vue&type=style&index=0&id=038de8ad&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038de8ad",
  null
  
)

export default component.exports